import React from 'react'
import { useParams } from 'react-router-dom'

import MarketingManagementUnit from '@components/marketing/partition/MarketingManagementUnit'

export default function MarketingManagementPage () {
  const { type = null } = useParams<any>()
  const [ title, setTitle ] = React.useState<string>('Маркетинг')

  return (
    <div className="MarketingManagementPage">
      <h1 className="u-heading">{ title }</h1>
      <MarketingManagementUnit 
        type={type} 
        onChangePage={setTitle} 
      />
    </div>
  )
}
